import React from 'react'
import { object, func, oneOfType, array, string } from 'prop-types'
import { translate } from 'react-i18next'

export const InquiryDetailsTextBlock = translate()(({ t, className, title, message, children }) => (
  <div className={`demandes__section ${className}`}>
    <h3>{ title }</h3>
    <p style={{ margin: 0 }}>{ message }</p>
    { children }
  </div>
))

InquiryDetailsTextBlock.propTypes = {
  t: func,
  className: string,
  title: string,
  message: string,
  children: oneOfType([ object, array, func ])
}



// WEBPACK FOOTER //
// ./src/components/inquiries/InquiryDetailsTextBlock.js